<script>
    import { getContext } from 'svelte';
    import { fly } from 'svelte/transition';
    import { quadIn } from 'svelte/easing';

    let visible = false

    const isMobile = getContext ('mobileDevice');
    const toggleSidepanel = () => {
        visible = !visible;
    }
</script>

<style>
    .Sidepanel {
        position: fixed;
        top: 0;
        left: 50px;
        width: 260px;
        height: 100%;
        background-color: var(--panels-primary-bg);
        border-right: 1px solid var(--forge-border-primary-color);
        z-index: 23;
    }

    .SidepanelHandle {
        position: fixed;
        bottom: 10px;
        right: 10px;
        width: 50px;
        height: 50px;
        line-height: 50px;
        border-radius: 3px;
        text-align: center;
        background-color: #859db3;
        color: #fff;
        z-index: 22;
        display: none;
    }
    .SidepanelClose {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 3px;
        font-size: 22px;
        text-align: center;
        z-index: 3;
        display: none;
    }

    .Sidepanel.mobile {
        display: none;
    }
    .SidepanelHandle.mobile, 
    .Sidepanel.mobile .SidepanelClose {
        display: block;
    }
    .Sidepanel.mobile.visible {
        display: block;
    }
    .Sidepanel.mobile {
        top: 50px;
        left: 0;
        width: 100%;
        height: calc(100% - 50px);
    }
</style>

<div class="SidepanelHandle" class:mobile={isMobile} on:click|stopPropagation={toggleSidepanel}>
    <i class="far fa-sliders-v"></i>
</div>
<div class="Sidepanel" class:visible class:mobile={isMobile}> <!-- transition:fly={{ x: -80, duration: 200 }} -->
    <div class="SidepanelClose" on:click|stopPropagation={toggleSidepanel}>
        <i class="far fa-times"></i>
    </div>
    <slot> </slot>
</div>